module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.858 29.258l-4-10A2.003 2.003 0 0 0 26 18h-6.016v4h4.662l2.4 6H4.954l2.4-6h4.63v-4H6c-.818 0-1.552.498-1.858 1.258l-4 10A2.002 2.002 0 0 0 2 32h28a2.002 2.002 0 0 0 1.858-2.742zM13.984 15.716V25c0 .552.462 1 1.016 1h2a.987.987 0 0 0 .984-1v-9.284c4-.892 6.008-3.994 6.008-7.716 0-4.418-3.58-8-7.996-8S7.99 3.582 7.99 8c0 3.722 1.994 6.824 5.994 7.716z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/location-pin-4.js
// module id = 1241
// module chunks = 14